export function FormIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.25951 9.02446H16.2367C16.9717 9.02446 17.5675 9.67986 17.5675 10.4883V11.9522C17.5675 12.7607 16.9717 13.4161 16.2367 13.4161H4.25951C3.52453 13.4161 2.92871 12.7607 2.92871 11.9522V10.4883C2.92871 9.67986 3.52453 9.02446 4.25951 9.02446ZM4.39259 10.4883V11.9522H16.1036V10.4883H4.39259ZM4.25951 3.16895H16.2367C16.9717 3.16895 17.5675 3.82435 17.5675 4.63282V6.0967C17.5675 6.90518 16.9717 7.56058 16.2367 7.56058H4.25951C3.52453 7.56058 2.92871 6.90518 2.92871 6.0967V4.63282C2.92871 3.82435 3.52453 3.16895 4.25951 3.16895ZM4.39259 4.63282V6.0967H16.1036V4.63282H4.39259ZM2.92871 14.88H11.712V16.3438H2.92871V14.88Z"
        fill="currentColor"
      />
    </svg>
  );
}
